import { Box, Typography } from "@mui/material";
import { FONT_PRIMARY } from "@/theme/typography";
import SouthIcon from "@mui/icons-material/South";
import AdvantageList from "./components/AdvantageList";
import VehicleAndGroupList from "./components/VehicleAndGroupList";

const FleetManagementTabContent = () => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
      }}
    >
      <Box
        sx={{
          gridColumn: { xs: "span 12", lg: "span 6" },
          gridRow: "span 1",
          order: "0",
          paddingTop: { xs: "0px", lg: "82px" },
        }}
      >
        <Typography
          variant="h5"
          sx={{
            maxWidth: { xs: "100%", lg: "600px" },
          }}
        >
          Set up groups of fleets based on whatever you want — location, vehicle
          type, cargo type.
        </Typography>
      </Box>
      <Box
        sx={{
          gridColumn: { xs: "span 12", lg: "span 6" },
          gridRow: "span 1",
          order: "2",
          paddingTop: { xs: "20px", lg: "0px" },
        }}
      >
        <AdvantageList />
      </Box>
      <Box
        sx={{
          paddingTop: { xs: "32px", lg: "0px" },
          gridColumn: { xs: "span 12", lg: "span 6" },
          gridRow: { xs: "span 1", lg: "span 2" },
          order: "1",
        }}
      >
        <Box
          sx={{
            padding: { xs: "15px 12px 30px", lg: "33px 26px 89px" },
            boxSizing: "border-box",
            border: "1px solid #ECECEC",
            borderRadius: "20px",
            position: "relative",
          }}
        >
          <Typography
            sx={{
              fontFamily: FONT_PRIMARY,
              fontWeight: "700",
              fontSize: { xs: "0.5rem", md: "1.125rem" },
              marginBottom: "19px",
            }}
          >
            Vehicles & Groups
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: "13px",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "0.375", md: "0.875" },
                marginRight: "8px",
              }}
            >
              Geofence name
            </Typography>
            <SouthIcon
              sx={{
                width: "14px",
                height: "14px",
              }}
            />
          </Box>
          <VehicleAndGroupList />
          <Box
            sx={{
              position: "absolute",
              width: "100%",
              height: "168px",
              bottom: "-24px",
              left: "0px",
              background:
                "linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default FleetManagementTabContent;
